function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrimaryPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.98047 3.76318L7.98047 12.8036",
    stroke: "#277154",
    style: {
      stroke: "#277154",
      stroke: "color(display-p3 0.1529 0.4431 0.3294)",
      strokeOpacity: 1
    },
    strokeWidth: 1.13005,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.502 8.2832L3.46154 8.2832",
    stroke: "#277154",
    style: {
      stroke: "#277154",
      stroke: "color(display-p3 0.1529 0.4431 0.3294)",
      strokeOpacity: 1
    },
    strokeWidth: 1.13005,
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryPlus);
export default __webpack_public_path__ + "static/media/primary_plus.225213a734ca69075ab0ad26840f5efe.svg";
export { ForwardRef as ReactComponent };